//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    punch: [],
    searchRequest: null,
  },
  mutations: {
    updatePunch(state, punch) {
      state.punch = punch;
    },
    updateSearchPunchRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadPunch({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));


    if (requestToSend.punchDate.startDate)
    {
        const date = moment(requestToSend.punchDate.startDate)
                    .endOf('d')
                    .toDate();
        console.log(date)
        console.log(date.getMonth())
        console.log(date.getDate())
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        {
            month = '0' + month
        }

        var day = date.getDate().toString()
        if (day.length === 1)
        {
            day = '0' + day
        }

        requestToSend.punchDate.startDate = date.getFullYear() + '-' + month + '-' + day
    }

    if (requestToSend.punchDate.endDate)
    {
        const date = moment(requestToSend.punchDate.endDate)
                    .endOf('d')
                    .toDate();

                    var month = (date.getMonth() + 1).toString()
                    if (month.length == 1)
                    {
                        month = '0' + month
                    }
            
                    var day = date.getDate().toString()
                    if (day.length == 1)
                    {
                        day = '0' + day
                    }
        requestToSend.punchDate.endDate = date.getFullYear() + '-' + month + '-' + day
    }
    else
    {
        const date = moment(requestToSend.punchDate.startDate)
                    .endOf('d')
                    .toDate();
        console.log(date)
        console.log(date.getMonth())
        console.log(date.getDate())
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        {
            month = '0' + month
        }

        var day = date.getDate().toString()
        if (day.length === 1)
        {
            day = '0' + day
        }

        requestToSend.punchDate.endDate = date.getFullYear() + '-' + month + '-' + day
    }

    //   if (requestToSend.punchDate.endDate) {
         
    //     requestToSend.punchDate.endDate = moment(requestToSend.punchDate.endDate)
    //       .endOf('d')
    //       .toDate();
    //   }
      
    //   if (requestToSend.punchDate.startDate && !requestToSend.punchDate.endDate) {
    //     requestToSend.punchDate.endDate = moment(requestToSend.punchDate.startDate)
    //       .endOf('d')
    //       .toDate();
    //   }
      if (requestToSend.users.length === 0 && requestToSend.usersInTeam && requestToSend.usersInTeam.length > 0) {
        requestToSend.users = requestToSend.usersInTeam;
      }

      //const result = await api.post('/api/w/ccic/punch', requestToSend);
      const result = await newAPIPost('/api/w/ccic/punch', requestToSend);
      commit('updateSearchPunchRequest', fallbackRequest);
      return commit('updatePunch', result);
    },
  },
  getters: {
    getPunch: state => state.punch,
  },
};
